import React from 'react';
import UnlinkButton from '../../../../pages/Dashboard/renderButtons/Unlink.js';

export default ({ row, loadData }) => <UnlinkButton reloadTables={loadData} row={row} />;
